import type { uzChannelsW2 } from "./uz-w2-channels";

/** Russian of `uz-w2-channels.ts`. */
export const ruChannelsW2: Record<keyof typeof uzChannelsW2, string> = {
  "channelsW2.paused": "На паузе",
  "channelsW2.pause": "Пауза",
  "channelsW2.resume": "Продолжить",
  "channelsW2.pauseTitle": "Поставить канал на паузу?",
  "channelsW2.pauseBody":
    "Этот аккаунт не будет отправлять сообщения, и ИИ не будет в нём отвечать. Входящие продолжают поступать. Сообщения в очереди подождут и уйдут после включения.",
  "channelsW2.pauseConfirm": "Поставить на паузу",
  "channelsW2.cancel": "Отмена",
  "channelsW2.failed": "Не удалось выполнить. Попробуйте ещё раз.",

  "channelsW2.held.label": "Неотправленные сообщения",

  "channelsW2.comment.hide": "Скрыть",
  "channelsW2.comment.suggested": "Спам: предлагается скрыть",
  "channelsW2.comment.hidden": "Скрыт в Instagram",
  "channelsW2.comment.hideFailed": "Не удалось скрыть комментарий.",

  "channelsW2.campaign.audience": "Аудитория",
  "channelsW2.campaign.sent": "Отправлено",
  "channelsW2.campaign.failed": "Ошибка",
  "channelsW2.campaign.skipped": "Пропущено",
  "channelsW2.campaign.pending": "Ожидает",
  "channelsW2.campaign.pause": "Пауза",
  "channelsW2.campaign.resume": "Продолжить",

  "settings.choice.stay_on_instagram": "Оставаться в Instagram",
  "settings.choice.invite_after_qualification": "Пригласить после квалификации",
  "settings.choice.redirect_now": "Сразу в Telegram",
  "settings.choice.ask_phone": "Спросить номер телефона",
};
